<template lang="pug">
div.home
    div.header
      div.logo
          img(:src='logoNav')
      div.title(@click="isChange = !isChange")
        span {{productData.product}}
        span.triangle(v-if="casePowerState")
        div.box(:class="isChange ? 'active' : '' ",v-if="casePowerState")
          div.TypeLine
            img(:src='logoNav')
            span {{productData.product}}
          div.TypeLine(@click="gotuPolicy")
            img(:src='logoNav')
            span {{productData.newProduct}}
      div.main-nav(v-if='!back')
          //- 解决刷新导航无效的问题
          div.meun-item(v-for='(v, index) of list',:class="{'nav-focus': v.path === $route.path}"
            :key="index",@click="changePage(index)") {{v.name}}
      div.user-right(v-if='!back')
        //- i.icon-msg.iconfont.icon-manual-install(@click='fun_switch',v-if="$role.role!=='student'" style='margin-right:30px;')
        Tooltip(trigger="hover" content="通知" placement="bottom" :disabled="isNotice").note
          div(v-if='!unreadList' ).notice
            i.icon-xiaoxitongzhitixinglingshenglingdang-xianxing.iconfont.icon(@click="isNotice = !isNotice;query();")
                ul.notice-menu(:class="isNotice ? 'active' : '' ")
                  li.notice-tag 通知
                  li.news-tag(@click='fun_go(x);query();')
                    div.test
                      i.icon-xiaoxitongzhitixinglingshenglingdang-xianxing.iconfont
                      div.type
                        div.title-tag 暂无消息
                  li.cover(@click='gonotice();query();') 查看全部
          Badge(v-else dot).notice
            i.icon-xiaoxitongzhitixinglingshenglingdang-xianxing.iconfont.icon(@click="isNotice = !isNotice;query();")
              ul.notice-menu(:class="isNotice ? 'active' : '' ")
                li.notice-tag 通知
                li.news-tag(v-for='(x,idx) in unreadList',v-if='idx<=0',@click='fun_go(x);checkReaded(x);query();')
                  //- div(v-if="x.isRead === 1").test
                  //- Badge(v-if="x.isRead === 0" dot).test
                  i.icon-xiaoxitongzhitixinglingshenglingdang-xianxing.iconfont
                  div(v-if='x.type==="老师审核自定义案例"').type
                    div.title-tag 您提交的案例已经被审核
                    div.time {{day(x.createdTime).format('YYYY-MM-DD HH:mm:ss')}}
                  div(v-if='x.type==="教师分配实训通知"').type
                    div.title-tag 您有新的实训待完成
                    div.time {{day(x.createdTime).format('YYYY-MM-DD HH:mm:ss')}}
                  div(v-if='x.type==="老师评分"').type
                    div.title-tag 您有新的实训报告可以下载
                    div.time {{day(x.createdTime).format('YYYY-MM-DD HH:mm:ss')}}
                  div(v-if='x.type==="密码重置提示"').type
                    div.title-tag 密码重置提示
                    div.time {{day(x.createdTime).format('YYYY-MM-DD HH:mm:ss')}}
                  div(v-if='x.type==="教师延续分配通知"').type
                    div.title-tag 您有案例实训待完成
                    div.time {{day(x.createdTime).format('YYYY-MM-DD HH:mm:ss')}}
                li.cover(@click='gonotice();query();') 查看全部
        Tooltip(trigger="hover" content="个人设置" placement="bottom" :disabled="isShow").personalOption
          img.head-img(:src='userInfo.src' @click='isShow = !isShow' style='margin-left:30px;margin-right:16px;')
          div.name(@click='isShow = !isShow') {{userInfo.name}}
            ul.user-menu(:class="isShow ? 'active' : '' ")
              li.cover(@click='gopersonal')
                Icon(type="ios-person-outline" size="20")
                a 个人中心
              li.cover(@click='fun_switch',v-if="$role.role!=='student'")
                Icon(type="md-swap" size="20")
                a 切换窗口
              li(style="width:120px;height:1px;background:rgba(210,221,236,1);")
              li.cover(@click='SignOut')
                Icon(type="ios-log-out" size="20")
                a 退出账号
      div.return(v-if='back' @click='gohome')
        i.icon-fanhui.iconfont
        p.revoke(@click="$router.push('/Student/home')") 返回
      div.mask(v-show='isNotice' :class="isNotice ? 'active' : '' " @click="isNotice = !isNotice")
      div.mask(v-show='isShow' :class="isShow ? 'active' : '' " @click="isShow = !isShow")
      div.mask(v-show='isDelete' :class="isDelete ? 'active' : '' " @click="changeDelete")
      div.mask(v-show='isChange' :class="isChange ? 'active' : '' " @click="isChange = !isChange")
    router-view
</template>

<script>
import dayjs from "dayjs";
import MyBus from "@/utils/main";
import RouteData from "@/mixins/RouteData";
import getProductName from "../../mixins/productName.js";
export default {
  mixins: [RouteData, getProductName],

  data() {
    return {
      day: dayjs,
      isChange: false,
      Unread: "",
      pageIndex: 0,
      back: false,
      isNotice: false,
      isShow: false,
      isDelete: false,
      noticelist: [],
      unreadList: [],
      list: [
        { name: "首页", path: "/Student/home" },
        { name: "流程演练", path: "/Student/case_list" },
        // { name: "政策分析" },
        { name: "资料中心", path: "/Student/datacenter" },
        { name: "自定义", path: "/Student/custom-case" }
      ],
      userInfo: {
        src: "",
        name: "",
        type: ""
      }
    };
  },
  watch: {
    $route() {
      if (this.$route.name === "notice_news") {
        this.back = true;
      } else {
        this.back = false;
      }
    }
  },
  methods: {
    // highLight() {
    //   let nowpath = this.$route.path;
    //   if ( || pageIndex === index) {

    //   }
    // },
    gotuPolicy() {
      window.location.href = "/policy/analysis.html#/Student/home";
    },
    fun_go(x) {
      // 跳转到审核页面
      switch (x.type) {
        case "教师分配实训通知":
          this.$router.push("/Student/case_list");
          this.pageIndex = 1;
          this.checkReaded(x);
          this.query();
          break;
        case "老师审核自定义案例":
          this.$router.push("/Student/custom-case");
          this.pageIndex = 4;
          this.checkReaded(x);
          this.query();
          break;
        case "老师评分":
          this.$router.push("/Student/see_ranking");
          this.pageIndex = 0;
          this.checkReaded(x);
          this.query();
          break;
        case "教师延续分配通知":
          this.$router.push("/Student/case_list");
          this.pageIndex = 1;
          this.checkReaded(x);
          this.query();
          break;
        default:
          break;
      }
      this.query();
    },
    checkReaded(x) {
      // 变为已读状态
      const data = {
        ids: [x.id]
      };
      data.ids = JSON.stringify(data.ids);
      this.$http.updateNotificationRead(data).then(res => {
        console.log(res);
      });
      this.query();
    },
    fun_switch() {
      let pageIndex = sessionStorage.getItem("teacherPageIndex");
      pageIndex = pageIndex === null ? 0 : pageIndex; // pageIndex 可能为null
      if (this.$role.role === "teacher") {
        this.$router.push({
          path: this.TeacherRouteData[pageIndex]
        });
      }
      // admin 没有切换学生账号功能
    },
    SignOut() {
      if (sessionStorage.getItem("isCAS")) {
        window.open("./api/user/login/out/cas");
        sessionStorage.removeItem("isCAS");
      }
      sessionStorage.clear();
      sessionStorage.clear();
      this.$router.push("/");
    },
    gonotice() {
      this.$router.push("/Student/notice_news");
    },
    gohome() {
      this.$router.push("/Student/home");
    },
    gocustom() {
      this.$router.push("/Student/custom-case");
      this.pageIndex = 4;
    },
    goprocess(path) {
      this.$router.push(path);
    },
    changePage(index) {
      if (this.pageIndex === index) {
        if (this.pageIndex === 0 && index === 0) {
          this.$router.push("/Student/home");
        }
        return false;
      }
      this.pageIndex = index;
      sessionStorage.setItem("pageIndex", this.pageIndex);
      sessionStorage.setItem("pagePath", this.list[this.pageIndex].name);
      this.$router.push({ path: this.list[index].path });
    },
    gopersonal() {
      this.$router.push("/Student/personal_center");
    },
    getByCode() {
      this.$http
        .userInfo({ code: this.$role.code })
        .then(res => {
          if (res.data.success) {
            //
            this.userInfo.name = res.data.data.name;
            this.userInfo.src = res.data.data.headImagePath;
            if (res.data.data.admin === true) {
              this.userInfo.type = "admin";
            } else if (res.data.data.student === true) {
              this.userInfo.type = "student";
            } else if (res.data.data.teacher === true) {
              this.userInfo.type = "teacher";
            }
            console.log(this.userInfo);
          }
        })
        .catch(() => {
          this.$Message.error("服务器异常");
        });
    },
    query() {
      // 查询未读通知个数
      const data = {
        userId: this.$role.code,
        types: JSON.stringify(["教师分配实训通知", "老师审核自定义案例", "老师评分"])
      };
      const unreadData = {
        isRead: 0,
        userId: this.$role.code,
        types: JSON.stringify([
          "教师分配实训通知",
          "老师审核自定义案例",
          "老师评分",
          "教师延续分配通知"
        ])
      };
      this.$http.queryUnreadnotice(data).then(res => {
        if (res.data.success) {
          this.Unread = res.data.data;
        }
      });
      // 查询外部通知
      this.$http.listWithoutNotification(unreadData).then(res => {
        if (res.data.success) {
          // 为此处的顶部栏未读消息
          this.noticelist = res.data.data.list;
          this.unreadList = res.data.data.list;
        }
      });
      this.$forceUpdate();
    },
    changeDelete() {
      this.isDelete = !this.isDelete;
      MyBus.$emit("isDelete", this.isDelete);
    }
  },
  created() {
    this.getByCode();
    this.query();
    this.$http.getClassMemberByCode({ id: this.$role.code }).then(res2 => {
      if (res2.data.success) {
        sessionStorage.setItem("classId", res2.data.data.classId);
      }
    });
    console.log(this);
    if (this.$role.role !== "student") {
      this.list.splice(
        this.list.findIndex(value => {
          return value.name === "自定义";
        }),
        1
      );
    }
  },
  mounted() {
    MyBus.$on("fun_notice", () => {
      this.query();
    });
    MyBus.$on("msg", e => {
      this.userInfo.name = e.name;
      this.userInfo.src = e.headImagePath;
    });
    MyBus.$on("change_mask", () => {
      this.isDelete = !this.isDelete;
      MyBus.$emit("isDelete", this.isDelete);
    });
  },
  computed: {
    casePowerState() {
      return this.casePower.includes("analysis");
    },
    casePower() {
      return this.$store.state.Case.pattern;
    }
  }
};
</script>

<style lang="stylus" >
.home
  background #EEF2F5
  min-height 100vh
  min-width 1360px
  .header
    width 100%
    height 60px
    background rgba(255, 255, 255, 1)
    box-shadow 0px -1px 0px 0px rgba(217, 217, 217, 0.5)
    display flex
    font-size 14px
    font-family MicrosoftYaHeiUI
    color rgba(42, 46, 54, 1)
    // min-width 1360px
    .logo
      width 24px
      height 18px
      margin-left 93px
      line-height 60px
      img
        width 100%
    .title
      font-size 14px
      font-family MicrosoftYaHeiUI
      color rgba(42, 46, 54, 1)
      margin-left 17px
      display flex
      align-items center
      position relative
      cursor pointer
      .triangle
        width 0
        height 0
        border-style solid
        box-sizing border-box
        border-width 5px
        border-color #000000 transparent transparent transparent
        margin-left 8px
        margin-top 4px
      .box
        width max-content
        height 80px
        background rgba(255, 255, 255, 1)
        box-shadow 0px 0px 6px 0px rgba(0, 0, 0, 0.2)
        border-radius 4px
        position absolute
        bottom -85px
        right -66px
        padding 4px 0
        display none
        &.active
          display block
          z-index 999
        .TypeLine
          width 100%
          height 36px
          line-height 36px
          cursor pointer
          &:hover
            background rgba(245, 245, 245, 1)
          &:first-child
            background rgba(245, 245, 245, 1)
            color #2D8CF0
          img
            width 24px
            height 18px
            vertical-align middle
            margin 9px 10px 0 16px
            float left
          span
            padding-right: 12px;
            float left
    .main-nav
      flex 1
      line-height 60px
      text-align left
      margin-left 39px
      .meun-item
        min-width 80px
        display inline-block
        margin-left 30px
        text-align center
        &:hover
          cursor pointer
          // border-bottom 2px solid #3A76D2
      .nav-focus
        border-bottom 2px solid #3A76D2
  .user-right
    // width 320px
    line-height 60px
    text-align left
    margin-right 109px
    display inline-flex
    align-items center
    .note
      .ivu-tooltip-rel
        .notice
          display initial
          .icon
            font-size 24px
            color #2A2E36
            .notice-menu
              position absolute
              left -140px
              display none
              z-index 999
              background rgba(255, 255, 255, 1)
              box-shadow 0px 2px 4px 0px rgba(0, 0, 0, 0.3)
              border-radius 8px
              width 300px
              height 160px
              &.active
                display block
                z-index 999
              .notice-tag
                font-size 14px
                font-family MicrosoftYaHeiUI
                color rgba(42, 46, 54, 1)
                height 48px
                line-height 48px
                // margin-left 16px
                text-align center
              .news-tag
                line-height 1em
                background rgba(246, 250, 254, 1)
                box-shadow 0px -1px 0px 0px rgba(128, 128, 128, 0.2)
                border-bottom 1px solid rgba(128, 128, 128, 0.2)
                height 72px
                // .test
                // display initial
              .iconfont
                float left
                font-size 24px
                color #508ff4
                margin 16px 11px 0 16px
              .type
                .title-tag
                  font-size 14px
                  font-family MicrosoftYaHeiUI
                  color #2a2e36
                  padding-top 10px
                  display -webkit-box
                  -webkit-box-orient vertical
                  -webkit-line-clamp 2
                  overflow hidden
                .time
                  font-size 12px
                  font-family MicrosoftYaHeiUI
                  color #808080
                  padding-top 5px
                  padding-left 52px
              .cover
                font-size 12px
                font-family MicrosoftYaHeiUI
                color rgba(53, 126, 212, 1)
                text-align center
                position relative
                top -12px
    .personalOption
      position relative
      .ivu-tooltip-popper
        left 5px !important
      .ivu-tooltip-rel
        display inline-flex
        align-items center
        .head-img
          width 32px
          height 100%
          border-radius 30%
          display inline-block
          position relative
        .name
          position relative
          display inline-block
          cursor pointer
        .user-menu
          position absolute
          left 0
          display none
          background rgba(255, 255, 255, 1)
          box-shadow 0px 2px 4px 0px rgba(0, 0, 0, 0.3)
          border-radius 4px
          &.active
            display block
            position absolute
            left -50px
            top 59px
            z-index 999
            border-radius 4px
          .cover
            width 120px
            height 40px
            display block
            border 1px solid #fff
            text-align center
            line-height 40px
            border-radius 4px
            margin 4px 0
            &:hover
              background #eef2f5
            a
              font-size 14px
              color rgba(42, 46, 54, 1)
  .return
    display inherit
    font-size 14px
    color #2A2E36
    line-height 60px
    position absolute
    right 167px
    .iconfont
      font-size 20px
      margin-right 17px
    .revoke
      cursor pointer
      font-size 14px
      font-family MicrosoftYaHeiUI
      color #2A2E36
  .mask
    background none
    &.active
      display block
      width 100vw
      height 100vh
      position fixed
      top 0
      left 0
      z-index 900
</style>
